namespace News {

    const KeyupRegex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    const KeySpecials = ["Enter", "Backspace", "Control", "Delete"];
    const operationSecondTimeoutMs = 1000; // 1 second

    let KeyupTimer: NodeJS.Timeout;

    export namespace Elenco {
        let filtriAttivati: boolean = false;
        let Filtro: FiltroNews;

        const dataAttrConfig = {
            ricercaTestuale: "sav-ricerca-news",
            btnClearFilter: "sav-reset-news-filtro",
            dataAttrDataFrom: "dataFromNews",
            dataAttrDataTo: "dataToNews"
        };

        type InfiniteScOpt = Controlli.UtilityTabella.BaseInfiniteScrollOptions;

        export function Init(
            baseUrlFiltro: string,
            tipoNews: number,
            divTabella: string,
            bodyTabella: string,
            rigaTabella: string,
            loaderInfiniteScroll: string,
            initRowPerPage: number
        ): void {
            ResetFiltro(initRowPerPage, tipoNews);
            const opzioni: InfiniteScOpt = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass: loaderInfiniteScroll };
            const tabella = Controlli.UtilityTabella.InitInfiniteScroll(
                opzioni, Controlli.Utility.HttpMethod.POST, Filtro, null
            );

            //Filtro testo
            FiltroRicercaTestuale(opzioni, tabella);

            //Filtro date
            $(`#${dataAttrConfig.dataAttrDataFrom}, #${dataAttrConfig.dataAttrDataTo}`).on("change", () => {
                Filtro.DataInizio = $(`#${dataAttrConfig.dataAttrDataFrom}`).val() as string;
                Filtro.DataFine = $(`#${dataAttrConfig.dataAttrDataTo}`).val() as string;
                ReloadTable(opzioni, tabella);
            });

            //Definisco l'evento di pulizia filtro
            $(`[data-${dataAttrConfig.btnClearFilter}]`).off("click").on("click", function () {
                if (filtriAttivati) {
                    ResetFiltro(initRowPerPage, tipoNews);
                    ReloadTable(opzioni, tabella);
                    CambiaStileBottoneResetFiltri();
                }
            });
        }

        function FiltroRicercaTestuale(opzioni: InfiniteScOpt, tabella: JQuery<HTMLElement>): void {
            $(`[data-${dataAttrConfig.ricercaTestuale}]`).off("keyup").on("keyup", function (event) {
                const searchTerm = $(this).val() as string;
                if (searchTerm !== Filtro.RicercaTestuale && (searchTerm === '' || KeyupRegex.test(searchTerm) || KeySpecials.includes(event.key))) {
                    Filtro.RicercaTestuale = searchTerm;
                    CambiaStileBottoneResetFiltri(true);
                    clearTimeout(KeyupTimer);
                    KeyupTimer = setTimeout(() => ReloadTable(opzioni, tabella), operationSecondTimeoutMs);
                }
            });
        }

        //Gestione reset dei filtri -----------------------------------------------------------
        function ResetFiltro(initRowPerPage: number, tipoNews: number): void {
            Filtro = {
                PaginaAttuale: 1,
                PagineTotali: 2,
                RighePerPagina: initRowPerPage,
                GenericId: 0,
                DataFine: null,
                DataInizio: null,
                RicercaTestuale: '',
                TipoNews: tipoNews
            } as FiltroNews;
            
            ResetUIFiltri();
        }
        function ResetUIFiltri(): void {
            $(`[data-${dataAttrConfig.ricercaTestuale}]`).val("");
        }
        function CambiaStileBottoneResetFiltri(attiva: boolean = false): void {
            const $btn = $(`[data-${dataAttrConfig.btnClearFilter}]`);
            if (attiva) {
                $btn.removeClass("link-primary").addClass("link-secondary text-decoration-underline");
                filtriAttivati = true;
            } else {
                $btn.removeClass("text-decoration-underline link-secondary").addClass("link-primary");
                filtriAttivati = false;
            }
        }

        function ReloadTable(opzioni: InfiniteScOpt, infiniteScrollTable: any): void {
            Controlli.Utility.fadeOutFadeIn($(opzioni.bodyTabella), () => {
                Controlli.UtilityTabella.ResetInfiniteScroll(
                    opzioni,
                    infiniteScrollTable,
                    Controlli.Utility.HttpMethod.POST,
                    Filtro
                );
            });
        }
    }

    class FiltroNews extends Controlli.UtilityTabella.BaseFiltriListaDto {
        TipoNews: number;
    }
}